import { Component } from "@angular/core";

@Component({
	moduleId: module.id,
	selector: "serviceNotAvailable",
	styleUrls: ["serviceNotAvailable.css"],
	templateUrl: "serviceNotAvailable.html"
})
export class ServiceNotAvailableComponent {}